export interface CognitiveStage {
  name: string
  open: boolean
  free: boolean
}

export interface CognitiveContent {
  title: string
  category: string
  status: string
  stages: CognitiveStage[]
  plays: number
  reports: number
}

function buildStages(openCount: number): CognitiveStage[] {
  return [1, 2, 3, 4, 5, 6].map((n) => ({ name: `레벨 ${n}`, open: n <= openCount, free: n === 1 }))
}

export const cognitive: CognitiveContent[] = [
  { title: '기억 카드 맞추기', category: '기억력', status: '고정 운영', stages: buildStages(4), plays: 1842, reports: 918 },
  { title: '순서 기억 훈련', category: '집중력', status: '고정 운영', stages: buildStages(3), plays: 1290, reports: 702 },
  { title: '소리 반응 게임', category: '반응속도', status: '고정 운영', stages: buildStages(2), plays: 612, reports: 344 },
]

export interface CognitiveReport {
  member: string
  title: string
  summary: string
  date: string
}

export const cognitiveReports: CognitiveReport[] = [
  { member: '정기태', title: '기억 카드 맞추기', summary: '주의집중 82점 · 기억력 78점', date: '2026-07-28' },
  { member: '김영숙', title: '순서 기억 훈련', summary: '반응속도 86점 · 정확도 91점', date: '2026-07-27' },
  { member: '이문호', title: '기억 카드 맞추기', summary: '주의집중 74점 · 반복권장', date: '2026-07-26' },
]

export const cognitiveLogsSpecification = {
  title: '인지로그',
  purpose: '인지 콘텐츠의 플레이 결과와 리포트 발행 현황을 조회합니다.',
  functions: [
    '기간과 콘텐츠 기준으로 참여 기록을 조회합니다.',
    '회원별 상세 리포트에서 정확도, 반응속도, 수행 결과를 확인합니다.',
  ],
  connections: [
    '인지플레이의 콘텐츠와 단계 정책을 기준으로 기록됩니다.',
    '회원관리의 인지 리포트 이력과 연결됩니다.',
  ],
  app: '사용자 앱에서 인지 과제를 완료하면 수행 결과가 리포트와 로그에 반영됩니다.',
}

export const cognitiveLogsDataModelGuide = [
  '기록 키: cognitive_play_id 또는 report_id, 연결 키: member_id + cognitive_content_id + stage_id',
  '필수 속성: 수행 시각, 정확도, 반응속도, 결과 요약, 열람 가능 여부',
]

export const cognitiveLogsImplementationGuide = [
  '화면 식별자: cognitiveLogs. 좌측 사이드 메뉴는 유지하고 메인 영역만 전환합니다.',
  '필수 데이터: 콘텐츠 ID, 회원, 수행일, 정확도, 반응속도, 리포트 결과.',
  '기간과 콘텐츠 조건으로 수행 기록을 조회하고 report_id로 상세 화면을 엽니다.',
  '기록은 조회 전용이며 리포트 원본을 목록에서 변경하지 않습니다.',
  '현재 화면은 운영 UI 목업입니다. 실제 개발에서는 API 응답, 저장 성공·실패, 권한 오류, 빈 목록 상태를 별도로 구현해야 합니다.',
]
